import { Image as RImage } from 'react-native'

import { motify } from '../core'

export const Image = motify(RImage)()
